module.exports = __webpack_public_path__ + "img/shopee.81c31375.png";